import { config } from 'app/config';

const def = [1024, 430];

export const getResolution = (type) => {
  const configRes = config.adv;
  if (!configRes || !configRes[type]) {
    return def;
  }

  return configRes[type];
};
